import { render, staticRenderFns } from "./non-real-del-card.vue?vue&type=template&id=f84e512e&"
import script from "./non-real-del-card.vue?vue&type=script&lang=ts&"
export * from "./non-real-del-card.vue?vue&type=script&lang=ts&"
import style0 from "./non-real-del-card.vue?vue&type=style&index=0&id=f84e512e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports